import { useEffect, useRef, useState, type FC } from 'react';
import { Header as MyHeader } from 'antd/es/layout/layout';
import { ReactComponent as LogoIcon } from '../assets/images/global-icons/logo.svg';
import { Link } from 'react-router-dom';
import { Flex, Select } from 'antd';
import { RootState } from '../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../redux/langSlice';
import languageOptions from '../data/language-options/languageOptions';
import NavMenu from './NavMenu';
import { logout } from '../redux/isAuthSlice';
import LoginModal from './Login-Modal/LoginModal';
import { useTranslation } from 'react-i18next';

interface PrivateHeaderProps {}

const Header: FC<PrivateHeaderProps> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isAuth = useSelector((state: RootState) => state.isAuth.isAuth);
  const currentLang = useSelector((state: RootState) => state.language.lang);
  const lastScrollY = useRef(0);
  const [isVisibleHeader, setIsVisibleHeader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLangChange = (value: string) => {
    dispatch(setLanguage(value));
  };

  const handleAuthBtn = (isEnter = true) => {
    !isEnter ? dispatch(logout()) : setIsModalOpen(true);
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const isScrollUp = currentScrollY < lastScrollY.current;

    setIsVisibleHeader(isScrollUp);
    lastScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <MyHeader className={`regularHeader ${isVisibleHeader ? undefined : 'hiddenHeader'}`}>
      <LoginModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <Link to="/" className="regularHeader__logo">
        <LogoIcon />
      </Link>
      <Flex vertical align="center" gap={10}>
        <Link to="/" className="regularHeader__title">
          <h1>{t('siteName')}</h1>
        </Link>
        <NavMenu className="headerNav" />
      </Flex>
      <Flex className="regularHeader__rightSection">
        <Select
          defaultValue={currentLang}
          onChange={handleLangChange}
          options={languageOptions}
          suffixIcon={<></>}
          showSearch={false}
          filterOption={false}
          className="regularHeader__rightSection__language"
          popupClassName="regularHeader__rightSection__language__dropdown"
        />
        <div className="regularHeader__rightSection__divider"></div>
        <button
          onClick={() => handleAuthBtn(!isAuth)}
          disabled={isModalOpen}
          className="regularHeader__rightSection__authBtn"
        >
          {isAuth ? t('logout') : t('login')}
        </button>
      </Flex>
    </MyHeader>
  );
};

export default Header;
